export default "__VITE_ASSET__By85ed$i__"